module.exports = require("ace-builds/src-noconflict/mode-json");